/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import { MODEL_TYPE_1_ID } from '#src/js/constants/models/modelTypes/index.js';
import getModelPageReducer from './support/getModelPageReducer.js';

export default getModelPageReducer(MODEL_TYPE_1_ID);
